import { render, staticRenderFns } from "./PromotionSubsetSku.vue?vue&type=template&id=6f84ca84&"
import script from "./PromotionSubsetSku.vue?vue&type=script&lang=ts&"
export * from "./PromotionSubsetSku.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports